<template>
    <div class="add_newAddResourse_mask"  v-if="addOk">
    <el-card class="newAdd_account">
        <div slot="header" class="clearfix" style="text-align:center;">
            <span style="line-height: 36px;">添加资源</span>
        </div>
        <div>
            <el-radio-group v-model="myType" style="margin-bottom: 20px;" @change="changeType">
                <el-radio-button :label="0" v-if="myType==0">图片</el-radio-button>
                <el-radio-button :label="1" v-if="myType==1">视频</el-radio-button>
            </el-radio-group>
        </div>
        <div class="resourseContent">
            <p>
                <span class="col-lg-3">标题：</span><el-input class="col-lg-4" v-model="title"></el-input>
            </p>
            <p>
                <span class="col-lg-3">内容：</span><el-input class="col-lg-4" type="textarea" v-model="content"></el-input>
            </p>
             <div style="margin:-10px 0 0 92px;color: #ff0200;font-size: 13px;">{{isVideo=='0'?"图片大小必须小于500kb;建议尺寸1280*800px":"视频大小必须小于30M;"}}</div>
            <p>
                <span class="col-lg-3">选择文件：</span>
                <el-upload
                    ref="upload"
                    class="col-lg-4"
                    action="http://upload.qiniu.com/"
                    :data="myForm"
                    method="post"
                    :on-preview="handlePreview"
                    name="file"
                    :on-remove="handleRemove"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                    :multiple="isMultiple"
                    :file-list="fileList">
                    <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
            </p>
            <p>
                <span class="col-lg-3">资源路径：</span><span class="col-lg-4">{{img}}</span>
            </p>
            <p style="text-align:center;"><el-button type="success" @click="commit" style="width: 240px;">提交</el-button></p>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $ajax from '../../https/config'
    export default {
      props: ['addShow', 'curType'],
      data () {
        return {
          labelPosition: 'right',
          loading: false,
          fileList: [],
          fileNum: 0,
          form: {},
          name: '',
          title: '',
          content: '',
          img: '',
          myType: this.curType,
          isMultiple: true,
          token: ''
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        isVideo: function () {
          return this.myType
        },
        myForm: {
          set: function (value) {
            this.form = value
          },
          get: function () {
            return this.form
          }
        }
      },
      created: function () {
        this.getUpToken()
      },
      methods: {
        boxColose () {
          this.fileNum = 0
          this.img = ''
          this.title = ''
          this.content = ''
          this.myType = this.curType
          this.$emit('closeAddAccount', false)
        },
        getUpToken () {
          var myUrl = (parseInt(this.isVideo) === 0) ? 'http://platform.songzb.com:32000/qiniuToken/image' : 'http://platform.songzb.com:32000/qiniuToken/video'
          var _this = this
          $ajax.get(myUrl, '', '', function (res) {
            _this.form.token = res.uptoken
          }, function () {
          })
        },
        handlePreview (file) {
        },
        handleRemove (file, fileList) {
          this.fileNum = 0
          this.img = ''
        },
        changeType () {
          this.fileNum = 0
          this.img = ''
          this.title = ''
          this.content = ''
          this.$refs.upload.clearFiles()
          this.getUpToken()
        },
        handleBeforeUpload (file) {
          var last, tType
          var tmyType = parseInt(this.myType)
          if (tmyType === 0) {
            tType = 'image-'
            last = file.name.split('.').pop()
            if (this.fileNum === 1) {
              this.$message({
                type: 'error',
                message: '一次只能上传一张图片'
              })
              return false
            }
            if (last !== 'jpg' && last !== 'png' && last !== 'jpeg') {
              this.$message({
                type: 'error',
                message: '图片格式错误'
              })
              return false
            }
            // if (file.size / 1024 > 1024) {
            //   this.$message({
            //     type: 'error',
            //     message: '图片大小超过500KB'
            //   })
            //   return false
            // }
          } else if (tmyType === 1) {
            tType = 'video-'
            last = file.name.split('.').pop()
            if (this.fileNum === 1) {
              this.$message({
                type: 'error',
                message: '一次只能上传一个视频'
              })
              return
            }
            // if (file.size / (1024 * 1024) > 30) {
            //   this.$message({
            //     type: 'error',
            //     message: '视频大小超过30MB'
            //   })
            //   return false
            // }
          }
          this.fileNum = 1
          var str = tType + (new Date().getTime()) + Math.ceil(Math.random() * 10) + '.' + last
          this.form.key = str
        },
        handleSuccess (response, file, fileList) {
          var type = parseInt(this.myType) === 0 ? 'image' : 'video'
          this.img = 'http://' + type + '.songzb.com/' + response.key
        },
        commit () {
          var tType
          var that = this
          if (parseInt(that.myType) === 0) {
            tType = 'IMAGE'
          } else if (parseInt(that.myType) === 1) {
            tType = 'VIDEO'
          }
          var params = {
            type: tType,
            title: that.title,
            content: that.content,
            url: that.img
          }
          if (this.title.trim() === '') {
            that.$message({
              type: 'error',
              message: '标题不能为空'
            })
            return
          }
          if (this.content.trim() === '') {
            that.$message({
              type: 'error',
              message: '内容不能为空'
            })
            return
          }
          if (this.fileNum === 0) {
            that.$message({
              type: 'error',
              message: '请选择要上传的资源！'
            })
            return
          }
          $ajax.post('/device/addAdResources', params, 'headers', function (res) {
            if (res.resultStatus === true) {
              that.$message({
                type: 'success',
                message: '添加广告资源成功！'
              })
              that.boxColose()
            }
          }, function () {
          })
        }
      }
    }
</script>
<style lang="scss">
  .add_newAddResourse_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;
  
  .newAdd_account {
    min-height: 530px;
    width: 500px;
    top: 20%;
    left: 45%;
    z-index: 101;
    margin-left: -200px;
    position: fixed;

    .el-card__header {
        padding: 10px
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .resourseContent {
        text-align: left;
    }
    .col-lg-3 {
        width: 20%;
        display: inline-block;
        font-weight: 700;
        color: #777;
        vertical-align: top;
    }
    .col-lg-4 {
        width: 72%;
        display: inline-block;

        textarea {
          height: 120px;
        }
    }

  }
  }
</style> 


// WEBPACK FOOTER //
// src/page/adMgr/adNewAddResourse.vue